module.exports = __webpack_public_path__ + "img/login_icon.7609c2bf.png";